<template>
    <modal
        name="media-gallery"
        ref="media-gallery"
        extra-class="full-screen-modal media-gallery-modal"
        :safe-close="true"
    >
        <!-- <template slot="header" slot-scope="props">
            <estate-data :estate="props.data.estate" :lang="lang" /> 

            <div class="estate-title">
                <h1 class="estate-title">
                    {{ props.data.estate.title }}
                </h1>

                <h2 class="estate-subtitle">
                    {{ props.data.estate.subtitle }}
                </h2>
            </div>

            <close-modal @click="props.close('media-gallery')" /> 
        </template> -->

        <template slot="body" slot-scope="props">
            <media-gallery 
                :buttons="props.data.buttons"
                :first-active="props.data.first_active"
                :active-image="props.data.active_image"
                :media="props.data.estate.media" 
            />
        </template>
    </modal>
</template>

<script>
import CloseModal from '../CloseModal'
// import EstateData from './Data'
import MediaGallery from './MediaGallery'
import Modal from '../Modal'

export default {
    components: {
        'close-modal': CloseModal,
        // 'estate-data': EstateData,
        'media-gallery': MediaGallery,
        'modal': Modal,
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail
        },
    },
}
</script>
